const STADIUM_IMG =
  "https://images.unsplash.com/photo-1679391029864-d46f366a456b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxmb290YmFsbCUyMHN0YWRpdW0lMjBmbG9vZGxpZ2h0cyUyMG5pZ2h0fGVufDB8fHx8MTc5MDQ1MDUwOHww&ixlib=rb-4.1.0&q=85";

const areas = [
  { title: "Club Partnerships", testid: "football-area-1" },
  { title: "Shirt & Training Rights", testid: "football-area-2" },
  { title: "Regional Partnerships", testid: "football-area-3" },
  { title: "Hospitality & Experiences", testid: "football-area-4" },
  { title: "Brand Introductions", testid: "football-area-5" },
  { title: "Commercial Rights", testid: "football-area-6" },
];

export default function FootballSection() {
  return (
    <section id="football" className="bg-[#F7F6F2] text-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end mb-16">
          <div>
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#0A0A0A] mb-6">
              02 — Discipline
            </p>
            <h2
              data-testid="football-section-header"
              className="font-heading font-light uppercase tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl"
            >
              Football
            </h2>
          </div>
          <p className="text-base sm:text-lg font-light text-neutral-700 leading-relaxed max-w-xl">
            Football gives brands access to deeply engaged communities, global
            audiences and year-round visibility. QUALIVE works across club
            partnerships, commercial rights, brand introductions and
            partnership strategy.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-0 border border-black/10">
          <div className="lg:col-span-2 relative overflow-hidden min-h-[320px]">
            <img
              src={STADIUM_IMG}
              alt="Football stadium under floodlights at night"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/25" />
          </div>
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2">
            {areas.map((a, i) => (
              <div
                key={a.title}
                data-testid={a.testid}
                className="group p-8 lg:p-10 border-t sm:border-t-0 sm:[&:nth-child(n+3)]:border-t border-black/10 sm:[&:nth-child(even)]:border-l hover:bg-[#0A0A0A] hover:text-[#F7F6F2] transition-colors duration-200"
              >
                <span className="font-mono-tech text-xs text-[#0A0A0A] tracking-[0.2em]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-heading font-medium text-xl mt-6 tracking-tight">
                  {a.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
